// Keep this entry chunk MINIMAL. The only static import is the global CSS (Vite
// extracts it to the render-blocking <link> the static hero needs to paint). The
// heavy React graph is dynamic-imported from ./bootstrap AFTER a double rAF, so
// the static above-the-fold hero (injected into #root by prerender-seo) paints
// FIRST — instead of LCP waiting for the whole app to download + evaluate (the
// ~573–728ms "render delay" seen in traces).
import '@/index.css'

let booted = false;
const boot = () => { if (booted) return; booted = true; import('@/bootstrap.jsx'); };

if (typeof requestAnimationFrame === 'function') {
  // First rAF runs before frame 1's paint; it schedules the second for frame 2.
  // Frame 1 paints the static hero, then the second rAF boots the app.
  requestAnimationFrame(() => requestAnimationFrame(boot));
  // Safety net: rAF is throttled/never fires in a backgrounded or prerendered
  // tab. Guarantee the app still boots so it can never get stuck on the static
  // hero. The `booted` guard prevents a double mount.
  setTimeout(boot, 1500);
} else {
  boot();
}
